import { ReactNode, useEffect, useRef, useState } from "react"
import styles from "./Tooltip.module.css"

type Props = {
  text: string
  children: ReactNode
}

export default function Tooltip({ text, children }: Props) {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const tooltipRef = useRef<HTMLDivElement>(null)
  const [tooltipStyle, setTooltipStyle] = useState<{ left: number; top: number }>({ left: 0, top: 0 })

  useEffect(() => {
    const updateTooltipPosition = () => {
      if (!wrapperRef.current || !tooltipRef.current) return

      const wrapperRect = wrapperRef.current.getBoundingClientRect()
      
      const left = wrapperRect.left + (wrapperRect.width / 2)
      const top = wrapperRect.top
      
      setTooltipStyle({ left, top })
    }

    const handleMouseEnter = () => {
      updateTooltipPosition()
    }

    const handleScroll = () => {
      if (wrapperRef.current?.matches(':hover')) {
        updateTooltipPosition()
      }
    }

    const wrapper = wrapperRef.current
    wrapper?.addEventListener('mouseenter', handleMouseEnter)
    window.addEventListener('scroll', handleScroll, true)
    window.addEventListener('resize', handleScroll)

    return () => {
      wrapper?.removeEventListener('mouseenter', handleMouseEnter)
      window.removeEventListener('scroll', handleScroll, true)
      window.removeEventListener('resize', handleScroll)
    }
  }, [])

  return (
    <div className={styles.tooltipWrapper} ref={wrapperRef}>
      {children}
      <div 
        className={styles.tooltip} 
        ref={tooltipRef}
        style={{
          left: `${tooltipStyle.left}px`,
          top: `${tooltipStyle.top}px`
        }}
      >
        {text}
      </div>
    </div>
  )
}
